function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0.920044 5.32936C5.1855 1.87378 10.5105 -0.0080947 16 2.61732e-05C21.7134 2.61732e-05 26.96 1.99603 31.08 5.32936L28.5667 8.44003C25.012 5.56073 20.5745 3.99289 16 4.00003C11.24 4.00003 6.86671 5.66403 3.43338 8.44003L0.920044 5.32936ZM5.10804 10.516C8.18885 8.02002 12.035 6.66075 16 6.66669C20.1254 6.66669 23.9147 8.10803 26.892 10.5147L24.3787 13.6267C22.0087 11.707 19.05 10.6617 16 10.6667C12.8267 10.6667 9.91204 11.776 7.62138 13.6267L5.10804 10.5147V10.516ZM9.29738 15.7027C11.1932 14.1666 13.56 13.3299 16 13.3334C18.5387 13.3334 20.8707 14.22 22.7027 15.7014L20.1894 18.8134C19.0043 17.8536 17.525 17.331 16 17.3334C14.4751 17.331 12.9958 17.8536 11.8107 18.8134L9.29738 15.7014V15.7027ZM13.4867 20.8894C14.1974 20.313 15.085 19.9989 16 20C16.952 20 17.8267 20.3334 18.5134 20.888L16 24L13.4867 20.888V20.8894Z",
  fill: "#4B617C"
});

function SvgInternet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 24,
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternet);
export default __webpack_public_path__ + "static/media/internet.2a91da8d.svg";
export { ForwardRef as ReactComponent };